import axios from "state/axios";

const LOGOUT_URL = '/api/logout';

const useLogout = () => {
    
    const token = localStorage.getItem('token');
    
    const logout = async () => {     
        try{
            await axios({
            url: LOGOUT_URL,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Authorization': `Bearer ${token}`},
            withCredentials:true,     
            });  
            localStorage.removeItem('token');
            window.location.reload();

        }catch (err){
            localStorage.removeItem('token');
            window.location.reload();

        }
    }
    return logout;
}
export default useLogout;